import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiPageableOutput } from '../../../../common/model/api-pageable.output';
import { ApiQuery } from '../../../../common/model/api.query';
import { MessageOutput } from '../model/message.output';

export interface FetchMessagesByCriteriaInput {
	readonly offset: number;
	readonly authorId: string;
	readonly chunkSize: number;
	readonly participantsId: string[];
}

export interface FetchMessagesByCriteriaParams {
	input: FetchMessagesByCriteriaInput;
}

@Injectable({ providedIn: 'root' })
export class FetchMessagesByCriteriaApiQuery extends ApiQuery<
	ApiPageableOutput<MessageOutput>,
	FetchMessagesByCriteriaParams
> {
	client = 'messaging';
	document = gql`
		query FetchMessagesByCriteria($input: FetchMessagesByCriteriaInput!) {
			fetchMessagesByCriteria(input: $input) {
				elements {
					id
					content
					authorId
					moduleId
					documentId
					visioSessionId
					participantsId
					updateTimestamp
					creationTimestamp
				}
				totalElements
			}
		}
	`;
	method = 'fetchMessagesByCriteria';
}
